<template>
	<DefaultTemplate>
		<div class="columns">
			<div class="column is-flex js-center ai-end" >
				<img src="@/assets/image.png">
			</div>
			<div class="column ">
				<div class="card rounded">
					<div class="card-content text-left pd-y-1">
						<h1 class="text-center mg-b-2">เข้าสู่ระบบ</h1>
						 <div
					        class="boxError th mg-b-3 rounded"
					        :class="{'shake animated': animated,'boxSuccess':!textError}"
					        @animationend="animated = false"
					        v-if="textError"
					     >{{textError}}</div>
					    <form  @submit.prevent="signin()">
					        <b-field label="อีเมล" class="mg-b-2">
					        	<b-input v-model="username"></b-input>
					        </b-field>
					        <b-field label="รหัสผ่าน" class="mg-b-3">
					        	<b-input type="password" v-model="password"></b-input>
					        </b-field>
					        <p class="text-right mg-b-3">
					        	<router-link to="/forgot-password">ลืมรหัสผ่าน</router-link>
					        </p>
					        <div class="text-center pd-b-2">
					        	<button type="submit" class="button submit" :style="styleObject">เข้าสู่ระบบ</button>
					        </div>
					    </form>
				        <div class="mg-t-1 text-center">
				        	<p>คุณยังไม่มีบัญชีเพื่อเข้าใช้งานระบบ? <router-link :to="`/signup/staff/${$route.params.formId}/${$route.params.adminId}`">สมัครสมาชิก</router-link></p>
				        </div>
					</div>
				</div>
			</div>
		</div>
	</DefaultTemplate>
</template>
<script>
    import DefaultTemplate from '@/template/DefaultTemplate'
    import { HTTP } from "@/service/axios.js";
    export default {
        components:{
            DefaultTemplate
		},data(){
			return{
				username:'',
				password:'',
				textError: "",
      			animated: false,
			}
		},
        computed:{
        	user(){
        		return this.$store.state.user
        	}
        },
        mounted(){
        	if(this.user != null){
        		this.joinForm(this.user)
        	}
        },
        methods: {
        	joinForm(user){
        		let obj = {
        			userId:user._id,
        			formId:this.$route.params.formId,
        			templateId:this.$route.params.adminId,
        		}
        		HTTP.post('/join/form',obj).then(res=>{
        			console.log('/join/form',res)
        			if (res.data.success) {
						let form = this.formData
        				if(res.data.obj != null){
        					form.push(res.data.obj)
        					this.$store.commit('SET_FORM',form)
        				}
        				this.setTheme(user)
	                    if (user.userLevel == 80) {
	                        this.$router.push('/assign-form')
	                    }else {
	                        if(form.length == 0){
	                            this.$router.push('/wait-form')
	                        }else{
	                            this.$router.push('/form-list')
	                        }
	                    }
	                }
	    		})
        	},
        	signin(){
				let obj = {
					email:this.username,
					password:this.password
				}
				HTTP.post('sign/in',obj).then(res=>{
					console.log('sign/in',res)
					if(res.data.success){
						this.textError = null;
              			this.animated = false;
						this.$store.commit('SET_USER',res.data.obj)
						this.joinForm(res.data.obj)
					}else{
						this.animated = true;
		                this.textError =
		                  "อีเมลหรือรหัสผ่านไม่ถูกต้อง กรุณากรอกใหม่อีกครั้ง";
					}
				}).finally(()=>{
					setTimeout(()=>{
						this.textError = null;
              			this.animated = false;
					},5000)
				}).catch(e => {
		          console.log("/api/user/signin/error", e);
		          if (!e.response || typeof e.response != 'undefined') {
		            this.textError =
		              "Cannot connect to server. Please contact the system administrator.";
		            if (e.response.status === 404) {
		              this.textError = "Server in maintenance";
		            } else if (e.response.status === 405) {
		              this.textError =
		                "อีเมลหรือรหัสผ่านไม่ถูกต้อง กรุณากรอกใหม่อีกครั้ง";
		            } else {
		              this.textError = e.response.data.message;
		            }
		          } else {
		            this.textError = e.response.data.message;
		          }
		        });
			},
			setTheme(user){
				HTTP.defaults.headers.common.Authorization = `Bearer ${user.token}`;
	    		HTTP.get(`/template/${user._id}`).then(res=>{
	    			console.log(`/template/${user._id}`,res)
	    			if(res.data.success){
	    				if(typeof res.data.obj.template != 'undefined'){
							let setBg = {
								label:'backGround',
								child:'color',
								value: user.userLevel == 60 ? res.data.obj.template.themeAdmin : res.data.obj.template.themeStaff 
							}
							this.$store.commit('SET_THEME',setBg)
							let setBt = {
								label:'button',
								child:'backGroundColor',
								value: user.userLevel == 60 ? res.data.obj.template.buttonAdmin : res.data.obj.template.buttonStaff
							}
							this.$store.commit('SET_THEME',setBt)
							let setBtHover = {
								label:'button',
								child:'backGroundColorHover',
								value:user.userLevel == 60 ? res.data.obj.template.buttonAdmin : res.data.obj.template.buttonStaff
							}
							this.$store.commit('SET_THEME',setBtHover)
							let setTitle = {
								label:'text',
								child:'title',
								value:res.data.obj.template.departmentName
							}
							this.$store.commit('SET_THEME',setTitle)
							let setSubtitle = {
								label:'text',
								child:'subTitle',
								value:res.data.obj.template.description
							}
							let setLogo = {
								label:'text',
								child:'logo',
								value:res.data.obj.template.logo
							}
							this.$store.commit('SET_THEME',setLogo)
						}
					}
				})
			}
        },
    }
</script>